import { render } from "./phones.vue?vue&type=template&id=990ef4dc&scoped=true&lang=pug"
import script from "./phones.vue?vue&type=script&lang=js"
export * from "./phones.vue?vue&type=script&lang=js"

import "./phones.vue?vue&type=style&index=0&id=990ef4dc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-990ef4dc"]])

export default __exports__